import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, Input, Button, Card, Alert, Typography } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useAuth } from '../../contexts/AuthContext';
import styled from 'styled-components';

const { Title, Text } = Typography;

const LoginContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: #f5f5f5;
`;

const LoginCard = styled(Card)`
  width: 100%;
  max-width: 420px;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.15);
  border-radius: 12px;
  border: 1px solid #e8e8e8;
  background: #ffffff;
  transform: translateY(-30px);
`;

const LogoContainer = styled.div`
  text-align: center;
  margin-bottom: 32px;
`;

const StyledTitle = styled(Title)`
  color: #262626 !important;
  margin-bottom: 8px !important;
  font-weight: 600 !important;
`;

const Subtitle = styled(Text)`
  color: #595959;
  font-size: 14px;
  font-style: italic;
`;

const LoginPage = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();

  const onFinish = async (values) => {
    setLoading(true);
    setError('');

    const result = await login(values.email, values.password);

    console.log('Login result:', result);

    if (result.success) {
      console.log('Login successful, requirePasswordChange:', result.requirePasswordChange);
      if (result.requirePasswordChange) {
        console.log('Navigating to /change-password');
        navigate('/change-password');
      } else {
        console.log('Navigating to /');
        navigate('/');
      }
    } else {
      console.error('Login failed:', result.error);
      setError(result.error);
    }

    setLoading(false);
  };

  return (
    <LoginContainer>
      <LoginCard>
        <LogoContainer>
          <StyledTitle level={2}>Family First</StyledTitle>
          <Subtitle>Because the family matters</Subtitle>
        </LogoContainer>

        {error && (
          <Alert
            message={error}
            type="error"
            closable
            onClose={() => setError('')}
            style={{ marginBottom: 24 }}
          />
        )}

        <Form
          form={form}
          name="login"
          onFinish={onFinish}
          autoComplete="off"
          layout="vertical"
        >
          <Form.Item
            label="Email"
            name="email"
            rules={[
              { required: true, message: 'Please input your email!' },
              { type: 'email', message: 'Please enter a valid email!' }
            ]}
            style={{ marginBottom: '24px' }}
          >
            <Input
              prefix={<UserOutlined />}
              placeholder="admin@homematters.com"
              size="large"
              style={{ height: '48px' }}
            />
          </Form.Item>

          <Form.Item
            label="Password"
            name="password"
            rules={[
              { required: true, message: 'Please input your password!' }
            ]}
            style={{ marginBottom: '36px' }}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="Enter your password"
              size="large"
              style={{ height: '48px' }}
            />
          </Form.Item>

          <Form.Item style={{ marginBottom: '0' }}>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              block
              size="large"
              style={{ height: '48px' }}
            >
              Sign In
            </Button>
          </Form.Item>
        </Form>

        <div style={{ textAlign: 'center', marginTop: 16 }}>
          <Text type="secondary" style={{ fontSize: 12, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px' }}>
            Made with love 
            <span style={{ 
              color: '#ff4d4f', 
              display: 'inline-block',
              animation: 'heartbeat 1.2s ease-in-out infinite'
            }}>
              ❤️
            </span>
          </Text>
        </div>
        
        <style>{`
          @keyframes heartbeat {
            0%, 100% {
              transform: scale(1);
            }
            10%, 30% {
              transform: scale(1.1);
            }
            20%, 40% {
              transform: scale(0.95);
            }
          }
        `}</style>
      </LoginCard>
    </LoginContainer>
  );
};

export default LoginPage;
